"use client";

import React from "react";
import { ImageBoxGrid } from "./image-box-grid";
import { cn } from "@/lib/utils";

interface ImageBoxGridSectionProps {
  title: string;
  description: string;
  features: {
    heading: string;
    description: string;
    image: any;
    href: string | null;
  }[];
  spacingTop?: boolean;
  spacingBottom?: boolean;
}

export const ImageBoxGridSection = ({
  title,
  description,
  features,
  spacingTop = false,
  spacingBottom = false,
}: ImageBoxGridSectionProps) => {
  return (
    <section
      className={cn(
        "bg-[#f6f6f6] py-14 lg:py-28 w-full h-full",
        spacingTop ? "mt-14 lg:mt-28" : "mt-0",
        spacingBottom ? "mb-14 lg:mb-28" : "mb-0"
      )}
    >
      <div className="w-full max-w-7xl mx-auto px-4">
        <div>
          <div className="flex flex-col gap-4 mb-10">
            <h2 className="text-2xl lg:text-4xl font-bold text-center md:max-w-[50%] mx-auto">
              {title}
            </h2>
            <p className="text-muted-foreground text-sm lg:text-base text-center">
              {description}
            </p>
          </div>
          <div>
            <ImageBoxGrid features={features} />
          </div>
        </div>
      </div>
    </section>
  );
};
